import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const IconHalfCircle = ({ style, color = 'black' }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.0002 4.50006C15.2545 4.50006 17.4169 5.3953 19.011 6.98932C20.605 8.58338 21.5002 10.7457 21.5002 13.0001C21.5002 15.2544 20.605 17.4167 19.011 19.0108C17.4169 20.6049 15.2546 21.5001 13.0002 21.5001V4.50006Z"
          fill={color}
        />
        <path
          d="M25 13C25 19.6274 19.6274 25 13 25C6.37258 25 1 19.6274 1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13Z"
          stroke={color}
          strokeWidth="2"
        />
        <path
          d="M13.0002 4.50006C15.2545 4.50006 17.4169 5.3953 19.011 6.98932C20.605 8.58338 21.5002 10.7457 21.5002 13.0001C21.5002 15.2544 20.605 17.4167 19.011 19.0108C17.4169 20.6049 15.2546 21.5001 13.0002 21.5001V4.50006Z"
          stroke={color}
          strokeWidth="2"
        />
      </svg>
    </Center>
  );
};
